import {useCallback} from 'react';

import {GridApi} from '../types/AgGridTypes';

export const useDeselectAll = (gridApi?: GridApi) =>
  useCallback(() => gridApi && gridApi.deselectAll(), [gridApi]);
